export default __webpack_public_path__ + "static/media/1.f412d82e.jpg";